import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { FormattedDate } from 'components/intl'
import { get } from 'lodash'
import { FormData } from 'components/misc'

export default class Answer extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired
  }

  render() {
    const { item } = this.props
    const type = get(item, 'profileQuestion.questionType')
    const label = get(item, 'profileQuestion.translatedText')
    let value = ''

    switch (type) {
      case 'OPTIONS':
        value = get(item, 'profileQuestionOption.translatedText')
        break
      case 'DATE':
        value = get(item, 'valueAsString') && (
          <FormattedDate value={item.valueAsString} />
        )
        break
      default:
        value = get(item, 'valueAsString')
    }

    return <FormData label={label}>{value}</FormData>
  }
}
